exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.Timeline .loadmore-text{opacity:1\n}\n.Timeline.-blocked{cursor:progress\n}\n.Timeline .timeline-heading{max-width:100%;flex-wrap:nowrap;align-items:center;position:relative\n}\n.Timeline .timeline-heading .loadmore-button{flex-shrink:0\n}\n.Timeline .timeline-heading .loadmore-text{flex-shrink:0;line-height:1em\n}\n.Timeline .timeline-footer{border:none\n}", ""]);

// exports
